import request from '@/libs/http/index'

// 统计相关 API 统一导出
export * from './revenue'
export * from './operational'
export * from './inventory'
export * from './satisfaction'

export interface StatisticsStoreOption {
  id: number
  name: string
}

export const getStatisticsStoreOptions = () => {
  return request.get<{ code: number; data: StatisticsStoreOption[] }>({
    url: '/clinic/statistics/store-options',
  })
}
